/**
 * Dynamic loader for MapLibre GL JS.
 * Checks if already loaded to avoid conflicts with client sites.
 */

const MAPLIBRE_CSS = 'https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.css';
const MAPLIBRE_JS = 'https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.js';

function loadCSS(href) {
  return new Promise((resolve) => {
    if (document.querySelector(`link[href="${href}"]`)) {
      resolve();
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.onload = resolve;
    link.onerror = resolve; // Don't block on CSS failure
    document.head.appendChild(link);
  });
}

function loadScript(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = () => reject(new Error(`Failed to load: ${src}`));
    document.head.appendChild(script);
  });
}

let maplibrePromise = null;

/**
 * Load MapLibre GL JS if not already present on the page.
 */
export function loadMapLibre() {
  if (window.maplibregl) return Promise.resolve();
  if (maplibrePromise) return maplibrePromise;

  maplibrePromise = Promise.all([
    loadCSS(MAPLIBRE_CSS),
    loadScript(MAPLIBRE_JS)
  ]);

  return maplibrePromise;
}
